<template>
  <div class="animated fadeIn">
    <ValidationObserver v-slot="{ invalid }">
      <b-row>
        <b-col>
          <transition name="fade">
            <b-card
              border-variant="info"
              header-bg-variant="primary"
              header-text-variant="white"
            >
              <div slot="header">
                <span data-font="22" class="mt-2">Create Template</span>
                <div class="card-header-actions">
                  <eb-button
                    class="mr-1 btn-primary"
                    text="Back"
                    @click="$router.push('/notification-template')"
                  >
                  </eb-button>
                </div>
              </div>
              <div>
                <b-row>
                  <b-col md="6">
                    <label class="label">Concern</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Concern"
                    >
                      <input
                        disabled
                        type="text"
                        placeholder="Concern"
                        class="form-control w-85"
                        v-model="templateToEdit[0].concern"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'">
                  <b-col>
                    <h4 class="pt-2 m-2">Email Template</h4>
                    <label class="label">Subject</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Subject"
                    >
                      <input
                        type="text"
                        placeholder="Subject"
                        maxlength="100"
                        class="form-control w-95"
                        v-model="templateToEdit[0].subject"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'">
                  <b-col>
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlEmailText"
                    >
                      <textarea
                        type="text"
                        rows="4"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-95"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'">
                  <b-col>
                    <label class="label">CSS (Optional)</label>
                    <ValidationProvider v-slot="{ errors }" name="CssText">
                      <textarea
                        type="text"
                        rows="4"
                        maxlength="1000"
                        placeholder="CSS (text Area)"
                        class="form-control w-95"
                        v-model="templateToEdit[0].css"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'">
                  <b-col md="6">
                    <label class="label">From Name</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="From Name"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="From Name"
                        class="form-control w-95"
                        v-model="templateToEdit[0].from.name"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="6">
                    <label class="label">From Email</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="From Email"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="From Email"
                        class="form-control w-95"
                        v-model="templateToEdit[0].from.email"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'SMS'">
                  <b-col>
                    <h4 class="pt-2 m-2">SMS Template</h4>
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlSmsText"
                    >
                      <textarea
                        rows="4"
                        type="text"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-95"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'SMS'">
                  <b-col>
                    <label class="label">Template Id</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="TemplateId"
                    >
                      <input
                        maxlength="100"
                        type="text"
                        placeholder="Template ID"
                        class="form-control w-95"
                        v-model="templateToEdit[0].templateId"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'WHATSAPP'">
                  <b-col md="12" class="pb-2 mt-3">
                    <h4>Whatsapp Template</h4>
                  </b-col>
                  <b-col md="6" class="pt-0">
                    <label class="label">Header (Optional)</label>
                    <h5 style="margin-top: 0px">
                      Add a title or choose which type of media you'll use for this
                      header.
                    </h5>
                    <eb-select
                      type="text"
                      label="text"
                      placeholder="Select Header"
                      :options="headerOptions"
                      :v-model="selectedHeaderOption"
                      :selected="selectedHeaderOption.text"
                    ></eb-select>
                    <div class="row mt-2">
                      <b-col class="mt-1 mb-2">
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'image'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="image/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'document'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="document/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'video'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="video/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-input
                          v-if="selectedHeaderOption.value == 'text'"
                          placeholder="Enter Title"
                          v-model="headerText"
                        >
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col md="6" class="pt-0">
                    <label class="label">Body</label>
                    <h5 style="margin-top: 0px">Enter the text for your message.</h5>
                    <div
                      class="row"
                      v-for="(bodyTxt, index) in templateToEdit[0].components[1]
                        .parameters"
                      :key="`textBody-${index}`"
                    >
                      <b-col md="9">
                        <b-form-input
                          :id="`textBody${index}`"
                          type="text"
                          label="text"
                          placeholder="Enter Body Text"
                          v-model="bodyTxt.text"
                        ></b-form-input>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          @click="
                            addBodyText(
                              bodyTxt,
                              templateToEdit[0].components[1].parameters
                            )
                          "
                          variant="success"
                          class="circularBtn"
                        >
                          <span>
                            <i class="fa fa-plus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          v-show="templateToEdit[0].components[1].parameters.length > 1"
                          @click="
                            removeBodyText(
                              index,
                              templateToEdit[0].components[1].parameters
                            )
                          "
                          variant="danger"
                          class="circularBtn"
                        >
                          <span>
                            <i class="fa fa-minus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <label class="label">Template Id</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Whatsapp Template ID"
                    >
                      <input
                        maxlength="100"
                        type="text"
                        placeholder="Enter Template ID"
                        class="form-control w-95"
                        v-model="templateToEdit[0].templateId"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'INAPP'">
                  <b-col>
                    <h4 class="pt-2 m-2">Inapp Template</h4>
                    <label class="label">Subject</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Subject"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="Subject"
                        class="form-control w-95"
                        v-model="templateToEdit[0].subject"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'INAPP'">
                  <b-col>
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlInappText"
                    >
                      <textarea
                        rows="4"
                        type="text"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-95"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    @click="submitUpdateTemplate"
                    class="btn btn-primary"
                    :disabled="invalid"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import cInput from "@/components/Common/CustomInput";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
export default {
  name: "CreateTemplate",
  components: {
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
    cInput,
  },

  data() {
    return {
      selectedTemplateOption: "email",
      selectedHeaderOption: "",
      headerOptions: [
        {
          text: "Document",
          value: "document",
        },
        {
          text: "Image",
          value: "image",
        },
        {
          text: "Video",
          value: "video",
        },
        {
          text: "Title",
          value: "text",
        },
      ],
      bodyText: [{ type: "text", text: "" }],
      templateIdWhatsapp: "",
      attachment: "",
      attachmentName: "",
      headerText: "",
    };
  },
  computed: {
    ...mapGetters({
      getEditTemplate: "emailTemplate/GetEditTemplate",
    }),
    templateToEdit() {
      if (Array.isArray(this.getEditTemplate) && this.getEditTemplate.length > 0) {
        let templateType = this.getEditTemplate.filter((obj) => {
          return obj._id === this.$route.params.id;
        });
        return templateType;
      }
    },
  },
  methods: {
    async submitUpdateTemplate() {
      let id = "";
      if (this.templateToEdit[0].concern) {
        if (
          this.templateToEdit[0].subject &&
          this.templateToEdit[0].from.name &&
          this.templateToEdit[0].from.email &&
          this.templateToEdit[0].service === "EMAIL"
        ) {
          let payload = {
            id: this.$route.params.id,
            data: {
              subject: this.templateToEdit[0].subject,
              body: this.templateToEdit[0].body,
              css: this.templateToEdit[0].css,
              from: {
                email: this.templateToEdit[0].from.email,
                name: this.templateToEdit[0].from.name,
              },
            },
          };
          await this.$store
            .dispatch("emailTemplate/updateEmailTemplate", payload, id)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Email Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
        if (this.templateToEdit[0].body && this.templateToEdit[0].service === "SMS") {
          let payload = {
            id: this.$route.params.id,
            data: {
              body: this.templateToEdit[0].body,
            },
          };
          await this.$store
            .dispatch("smsTemplate/updateSmsTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
        if (this.bodyText.text != "" && this.templateToEdit[0].service === "WHATSAPP") {
          let headerParameter = [];
          let bodyParameter = [];
          if (this.selectedHeaderOption.value == "text") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              text: this.headerText,
            });
          } else if (this.selectedHeaderOption.value == "document") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              document: {
                link: this.attachment,
                filename: this.attachmentName,
              },
            });
          } else if (this.selectedHeaderOption.value == "image") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              image: { link: this.attachment },
            });
          } else if (this.selectedHeaderOption.value == "video") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              video: { link: this.attachment },
            });
          }
          this.templateType[0]?.components[1]?.parameters?.map((oneText) =>
            bodyParameter.push({
              type: "text",
              text: oneText.text,
            })
          );
          let payload = {
            concern: this.selectedOption,
            serviceName: "batch",
            whatsapp: {
              templateId: this.templateIdWhatsapp,
              components: [
                {
                  type: "header",
                  parameters: headerParameter,
                },
                {
                  type: "body",
                  parameters: bodyParameter,
                },
              ],
              active: true,
            },
          };
          await this.$store
            .dispatch("whatsappTemplate/createWhatsappTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Create Template",
                type: "error",
              });
            });
        }
        if (
          this.templateToEdit[0].body &&
          this.templateToEdit[0].subject &&
          this.templateToEdit[0].service === "INAPP"
        ) {
          let payload = {
            id: this.$route.params.id,
            data: {
              subject: this.templateToEdit[0].subject,
              body: this.templateToEdit[0].body,
            },
          };
          await this.$store
            .dispatch("inappTemplate/updateInappTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
    },
    addBodyText(value, textType) {
      textType.push({ value: "" });
      console.log(this.bodyText, "AddBODY");
    },
    removeBodyText(index, textType) {
      textType.splice(index, 1);
      console.log(this.bodyText, "RemoveBODY");
    },
    readFile(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      this.attachmentName = e.target.files[0].name;
      reader.onload = () => {
        this.uploadFile(reader.result);
      };
      reader.onerror = (err) => {
        this.$toasted.error("Image not uploaded..please try again!");
        console.log(err);
      };
    },
    async uploadFile(file) {
      let dataobj = {
        image: file,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.attachment = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
          console.log(error);
          this.loading = false;
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
  },

  async mounted() {
    this.loading = true;
    if (this.$route.params && this.$route.params.id) {
      await this.$store.dispatch("emailTemplate/editTemplate", this.$route.params.id);
    } else if (!this.$route.params || !this.$route.params.id) {
      this.$router.push("/emailTemplate/fetchTemplateAction");
    }
    this.loading = false;
  },
};
</script>
<style>
.label {
  background-color: #ffff;
  padding: 8px;
  font-family: "Lato";
  font-weight: bold;
}

.form-control {
  height: calc(2.2125rem + 8px);
}

.vs__dropdown-toggle {
  border-radius: 0.25rem !important;
}

.circularBtn {
  height: 40px;
  width: 40px;
  border-radius: 100%;
  text-align: center;
}
</style>
